import SampleVehicleModelWriteDTO from '../sample-vehicle-model/SampleVehicleModelWriteDTO';

export default class VehicleModelWriteDTO {

    public id: number | undefined;
    public modelSeries: string | undefined;
    public label: string | undefined;
    public brandId: number | undefined;
    public bodyTypeId: number | undefined;
    public carClassId: number | undefined;
    public availabilityDate: string | undefined;
    public expirationDate: string | undefined;
    public samples: SampleVehicleModelWriteDTO[] | [];
    public imageId: number | undefined;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined
        this.modelSeries = data['modelSeries'] || undefined;
        this.label = data['label'] || undefined;
        this.brandId = data['brandId'];
        this.bodyTypeId = data['bodyTypeId'];
        this.carClassId = data['carClassId'];
        this.availabilityDate = data['availabilityDate'] || undefined;
        this.expirationDate = data['expirationDate'] || undefined;
        this.samples = data['samples'] || [];
        this.imageId = data['imageId'] || undefined;

        if (data['image']) {
            this.imageId = data['image'].id;
        }
    }
}